import React, { useMemo } from "react";
import {
  convertMcBimSpaceToPixPolygon,
  formatMcBimItemsToPixPolygons,
  getDeeplyNestedValue,
  getDeviceCategoryForMcBimItem,
  getPixPolygonCeilingGrids,
  roomHasCeilingCoordinates,
} from "./utils";
import PixBimViewer from "./components/PixBimViewer/PixBimViewer";
import { useAppSelector } from "./app/hooks";
import { useGetMultiplacerSingleRoomQuery } from "../openapi";
import { IMcBimItem } from "@backend/src/schemas";
import { selectHttpCurrentProjct } from "./projectSelectors";

const SingleSpaceWithItemsViewer: React.FC<{
  mcbimSpace: IMcBimItem;
  mcbimItemsInSpace: IMcBimItem[];
}> = ({ mcbimSpace, mcbimItemsInSpace }) => {
  const rotation = useAppSelector((state) => state.design.rotation);

  const project = useAppSelector(selectHttpCurrentProjct);

  const mcBimItemsFormated = useMemo(() => {
    return mcbimItemsInSpace?.map((item) => {
      return {
        ...item,
        deviceCategory: getDeviceCategoryForMcBimItem({
          mcbimItem: item,
          compCodePath: project.compCodePath,
        }),
      };
    });
  }, [mcbimItemsInSpace]);

  const allPixPolygons = useMemo(() => {
    if (mcbimSpace == null) return [];
    const spacePixPolygon = convertMcBimSpaceToPixPolygon(mcbimSpace, false);
    // convertDevicesToPixPolygons
    //const devicesPixPolygons = formatMcBimItemsToPixPolygons(mcBimItemsFormated ?? [], project?.compCodePath as string);
    const devicesPixPolygons = formatMcBimItemsToPixPolygons({
      mcBimItems: mcBimItemsFormated ?? [],
      showDuctSegment: false,
      compCodePath: project?.compCodePath as string,
    });
    if (spacePixPolygon == null) return [];
    return [spacePixPolygon, ...devicesPixPolygons];
  }, [mcbimSpace, mcbimItemsInSpace, mcBimItemsFormated]);

  const { data: room } = useGetMultiplacerSingleRoomQuery({
    roomNumber: mcbimSpace.name as string,
    projectNo: project?.projectNo as number,
  });

  const hasCeiling = room ? roomHasCeilingCoordinates(room) : false;

  const pixPaths =
    hasCeiling && room != null
      ? getPixPolygonCeilingGrids({
          mcbimSpace: mcbimSpace,
          room: room,
        })
      : [];

  return (
    <>
      {!hasCeiling && (
        <div>
          Room has no ceiling coordinates. Synkorniser fra revit. PNS
          {getDeeplyNestedValue(mcbimSpace, project?.pnsPath as string) ?? "No PNS"}
        </div>
      )}
      <PixBimViewer angle={rotation} paths={pixPaths} polygons={allPixPolygons ?? []} />
    </>
  );
};

export default SingleSpaceWithItemsViewer;
